import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles(
  {
    label: {
      marginBlockEnd: 4,
      padding: [4, 0, 4, 8],
    },

    btn: {
      alignItems: 'center',
      borderRadius: 8,
      backgroundColor: 'var(--x-bg-14)',
      color: 'var(--x-breadcrumb-last)',
      display: 'flex',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '20px',
      marginBottom: 8,
      padding: [10, 12],

      '&:hover': {
        backgroundColor: 'var(--x-text-color-8)',
        color: 'var(--x-black)',
      },
    },

    btnSelected: {
      backgroundColor: 'var(--x-bg-15)',
      color: 'var(--x-accent-2-1)',
      cursor: 'initial',

      '&:hover': {
        backgroundColor: 'var(--x-bg-15)',
        color: 'var(--x-accent-2-1)',
      },

      '& $createIcon': {
        fill: 'var(--x-accent-2-1)',
      },
    },

    btnIcon: {
      fill: 'var(--x-breadcrumb-last)',
      height: 20,
      marginRight: 8,
      width: 20,

      '&:hover': {
        color: 'var(--x-black)',
      },
    },

    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      listStyleType: 'none',
    },

    textContainer: {
      alignItems: 'center',
      borderRadius: 8,
      display: 'flex',
      cursor: 'pointer',
      padding: [6, 8],

      '&:hover': {
        backgroundColor: '#F2F2F2',
      },

      '&+.MenuSubcategoriesVisible': {
        marginTop: 8,
      },
    },

    textContainerSelected: {
      backgroundColor: '#F2F2F2',
      fontWeight: 600,

      '& $categoryText': {
        color: '#000',
        fontWeight: 600,
      },
    },

    categoryText: {
      color: '#4c4c4c',
      display: 'block',
      marginLeft: 12,
      paddingBlock: 4,
    },

    smallIcon: {
      fill: 'var(--x-black)',
      transition: 'transform .25s',
    },

    smallIconInverse: {
      transform: 'rotate(180deg)',
    },

    subcategories: {
      borderLeft: '1px solid var(--x-bg-8)',
      display: 'none',
      flexDirection: 'column',
      gap: 2,
      listStyle: 'none',
      marginLeft: 16,
      paddingLeft: 18,

      '&.MenuSubcategoriesVisible': {
        display: 'flex',
      },
    },

    subcategory: {
      borderRadius: 8,
      color: 'var(--x-breadcrumb-last)',
      display: 'block',
      fontWeight: 600,
      fontSize: 12,
      lineHeight: '16px',
      padding: 8,

      '&:hover': {
        color: '#4C4C4C',
        backgroundColor: 'rgba(128, 128, 128, 0.1)',
      },
    },

    selected: {
      color: 'var(--x-accent-2-1)',
      cursor: 'default',
      backgroundColor: 'var(--x-bg-15)',

      '&:hover': {
        color: 'var(--x-accent-2-1)',
        backgroundColor: 'var(--x-bg-15)',
      },
    },
  },
  {
    name: 'Menu',
  },
);
